import React from 'react';
import {
  Link,
} from 'react-router-dom';

import { resolveTo } from '~/commons/helpers';

const Header = ({
  breadcrumb = undefined,
  children,
}) => (
  <header className="pt-5 pb-3">
    {breadcrumb && (
      <nav>
        <div className="breadcrumb">
          {breadcrumb.map((b, i) => (
            <div key={i} className="breadcrumb-item">
              <Link to={resolveTo(b.to)}>
                {b.children}
              </Link>
            </div>
          ))}
        </div>
      </nav>
    )}
    <h1>{children}</h1>
  </header>
);

export default Header;
